export default __webpack_public_path__ + "static/media/WallNotification_Atmore-Picture.a9cdcd62.png";